import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api } from "../../lib/api";
import { fmtINR } from "../../lib/constants";

export default function RateTicker() {
  const [rate, setRate] = useState(null);
  useEffect(() => {
    const load = () => api.get("/api/rates/current").then((r) => setRate(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60_000);
    return () => clearInterval(id);
  }, []);
  if (!rate) return <div className="ticker-row h-8" />;
  const items = [
    { label: "GOLD 24K / 10g", val: rate.gold_24k * 10 },
    { label: "GOLD 22K / 10g", val: rate.gold_22k * 10 },
    { label: "GOLD 20K / 10g", val: rate.gold_20k * 10 },
    { label: "GOLD 18K / 10g", val: rate.gold_18k * 10 },
    { label: "SILVER / 10g", val: rate.silver * 10 },
  ];
  return (
    <div className="ticker-row py-2" data-testid="rate-ticker">
      <Marquee gradient={false} speed={45} pauseOnHover>
        {items.concat(items).map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-3">
            <span className="text-gold-light tracking-widest font-semibold">{it.label}</span>
            <span className="text-pearl">{fmtINR(it.val)}</span>
            <span className="text-gold-light/40">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
